import { Box, Checkbox, FormControlLabel } from "@mui/material";

import type { ReactNode } from "react";

interface Props {
  fields: { guid: string; name: string }[];
  selectedIds: string[];
  onToggle: (guid: string) => void;
  disabled?: boolean;
  error?: boolean;
  renderLabel?: (guid: string, name: string) => ReactNode;
}

export default function FieldCheckboxPicker({
  fields,
  selectedIds,
  onToggle,
  disabled = false,
  error = false,
  renderLabel,
}: Props) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        borderRadius: "8px",
        border: "1px solid",
        borderColor: error ? "error.main" : "rgba(0, 0, 0, 0.12)",
        backgroundColor: "white",
        maxHeight: 220,
        overflowY: "auto",
        py: 0.5,
        px: 1,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      {[...fields]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((field) => (
          <FormControlLabel
            key={field.guid}
            control={
              <Checkbox
                checked={selectedIds.includes(field.guid)}
                disabled={disabled}
                onChange={() => onToggle(field.guid)}
                size="small"
                sx={{
                  color: "rgba(0,0,0,0.3)",
                  "&.Mui-checked": { color: "#7EC254" },
                }}
              />
            }
            label={
              renderLabel ? renderLabel(field.guid, field.name) : field.name
            }
            sx={{
              mx: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
        ))}
    </Box>
  );
}
